import Pdf3 from "./other/em3_justified_CR.pdf";

const PublicationsData = [
  {
    authors: "Aida Kostikova, Ole Pütz, Steffen Eger, Olga Sabelfeld, Benjamin Paassen",
    title:
      "LLM Analysis of 150+ years of German Parliamentary Debates on Migration Reveals Shift from Post-War Solidarity to Anti-Solidarity in the Last Decade",
    venue: '"Computational Linguistics" (CL), 2026',
    paper: "https://arxiv.org/abs/2509.07274",
    abstract: (
      <p>
        Migration has been a core topic in German political debate, from postwar expellee displacement to labor migration and recent refugee movements. Large-scale analysis of such political discourse has traditionally required extensive manual annotation, limiting coverage. Large language models (LLMs) offer a scalable alternative. Using a theory-driven annotation scheme, we examine how well LLMs annotate subtypes of solidarity and anti-solidarity in German parliamentary debates and whether the resulting labels support valid downstream inference. We first evaluate multiple LLMs across model size, prompting strategies, fine-tuning, historical versus contemporary data, and systematic errors. The strongest models, especially GPT-5 and gpt-oss-120B, achieve macro- F1 scores comparable to human agreement, although their systematic errors can bias downstream results. We therefore combine soft-label model outputs with Design-based Supervised Learning (DSL) to reduce bias in long-term trend estimates. Beyond the methodological evaluation, we interpret the resulting annotations from a social-scientific perspective across the Reichstag (1867- 1933), West German Bundestag (1949-1990) and Re-Unified German Bundestag (1990-2025) corpus to trace trends in solidarity and anti-solidarity toward migrants, with detailed analysis of postwar Germany (1949-1957) and contemporary Germany (2009-2025). We find relatively high levels of solidarity in the postwar period, especially in group-based and compassionate forms, and a marked rise in anti-solidarity since 2015. We argue that LLMs can support large-scale social-scientific text analysis, but their outputs require rigorous validation and, where systematic errors are present, statistical correction. 
      </p>
    ),
  },
  {
      authors: "Yiqi Liu, Flavjo Tomori, Nafise Sadat Moosavi, Steffen Eger, Chenghua Lin",
    title:
      "Feedback as an Interface: Controlling Form and Detail in LLM Translation Refinement",
    venue: "AACL 2026",
    paper: "https://arxiv.org/abs/2610.15661",
    abstract: (
      <p> 
        Feedback presentation shapes how LLMs use evaluator judgments during translation refinement. We introduce a machine translation protocol that keeps the evaluator score, main issue, and recommendation fixed while varying feedback form and supporting detail. Across seven models and six translation directions, low-load feedback outperforms high-load feedback in all 42 translator-direction settings under xCOMET. On the 29,400-record rewriting subset, mean xCOMET scores multiplied by 100 are 83.30 for low-load feedback and 80.67 for high-load feedback; the full-matrix original-translation reference mean is 83.46. MetricX-24 supports the low-load advantage on a stratified subset. A no-feedback second pass yields a small improvement over the original translations, and direct evaluator prompting reproduces the low-load advantage without a separate rewriting stage. These results show that compact feedback limits the quality loss from evaluator-guided refinement in the evaluated high-resource MT settings. 
      </p>
    ),
  },
  {
      authors: "Yujun Wang, Ehud Reiter, Shimei Pan, Steffen Eger, Wei Zhao",
      title:
        "Beyond Accuracy: Community Perspectives on Machine Translation",
      venue: "EMNLP 2026 Main",
      paper: "https://arxiv.org/abs/2606.09655",
      abstract: (
        <p> 
          This paper explores the limitations of relying solely on accuracy metrics in evaluating machine translation systems. We present a comprehensive analysis of community perspectives on the shortcomings of accuracy-based evaluation and propose a more nuanced approach that considers the broader context and impact of translation quality.Despite remarkable progress in machine translation (MT), non-AI communities have raised growing concerns about MT systems, suggesting a noticeable gap between technical advancement and the needs of real-world users. For instance, while NLP researchers focus on benchmark performance, end users care about ethical concerns, trust, reliability, costs, and more. We argue that listening to various user communities is essential so that research efforts would be directed towards the problems that the communities care about. To this end, we present a large-scale analysis, for the first time, that investigates what four stakeholder communities (AI developers, professional translators, language learners, and language service providers) post about MT technology on social media. To do so, we construct a dataset of 79,286 posts and comments from Reddit, Facebook, Bluesky, and Mastodon from 2019 to 2025, and analyse where these communities disagree, and how and why. Overall, we find that communities often disagree, and even show strong conflicts due to polarised sentiments on topics such as translation quality, efficiency, and reliability. This is because these communities approach these topics differently: the AI community frames them as technical and computational problems, while non-AI (user) communities care more about quality nuances, time savings, user trust, and broader social issues. 
        </p>
      ),
  },
    {
      authors: "Maria Kunilovskaya, Gagan Bhatia, Lisa Sophie Albertelli, Yanran Chen, Christian Greisinger, Lotta Kiefer, Christoph Leiter, Subhadeep Roy, Tewodros Achamaleh, Muhammad Arslan Manzoor, Sebastian Pohl, Yufang Hou, Steffen Eger",
      title:
        "Who Annotates in NLP? A Large-scale Assessment of Human Annotation Reporting between 2018 and 2025",
      venue: "EMNLP 2026 Main",
      paper: "https://arxiv.org/abs/2606.02255v3",
      abstract: (
        <p> 
          Human annotation is the empirical foundation of much NLP research, from dataset construction to model evaluation, but papers often leave unclear who produced the annotations and how the annotation process was controlled. We provide the first large-scale, task-level audit of human annotation reporting across major NLP venues, asking which annotation details are documented, which are missing, and how reporting varies across time, topic, venue, and intended use of human judgment. We introduce a unified taxonomy of annotation-reporting practices and validate an LLM-assisted extraction pipeline against Annotated-gold, a human-adjudicated gold standard of 41 papers and 72 annotation tasks, where the best model reaches human-comparable agreement with adjudicated labels, with Krippendorff's alpha of 0.606 versus 0.585 for human-human agreement. Using this pipeline, we construct Annotated-llm, a dataset covering ACL-venue papers from 2018-2025, with 2,667 extracted annotation tasks from 1,603 papers, and find that papers frequently report operational details such as recruitment strategies, annotator expertise, and annotation volume, but often omit details needed to assess annotation validity, including training, language proficiency, compensation, socio-demographics, adjudication, and agreement values, especially in model-evaluation studies. Our results show that annotation reporting in NLP has improved over time but remains uneven, and they establish a scalable framework and bare-minimum reporting recommendations for making human annotation more reliable, reproducible, and interpretable. 
        </p>
      ),
  },
  {
    authors: "Yanran Chen, Steffen Eger",
    title:
      "Justification of Emotional Appeal in Computational Argumentation",
    venue: "EMNLP 2026 Main",
    paper: Pdf3,
    abstract: (
      <p> 
        Emotional appeals (EAs) are often treated as fallacious in computational
        argumentation, yet they may be justified when warranted by the context. We
        introduce the task of predicting EA justification and present the first
        human-annotated dataset for this task, covering 1,176 argument--context pairs.
        Grounded in philosophical literature, our framework evaluates EA justification
        along logical and emotional dimensions. Human annotations show that
        justification criteria form a shared latent judgment space, with evidential
        proportionality and normative acceptability most strongly associated with
        overall justification. We further find that EAs without logical support are not
        always judged fully unjustified, and stronger EAs are not necessarily judged
        less justified. Finally, LLM experiments show that EA justification prediction
        remains challenging.
      </p>
    ),
  },
  {
    authors: "Wang Y, Chen Y, Wang Y, Eger S, Buschmeier H",
    title:
      "Syntactic complexity convergence in dialogue: Analysis of the phenomenon and application to LLM detection",
    venue: "EMNLP 2026 Main",
    paper: "https://pub.uni-bielefeld.de/record/3019940",
    abstract: (
      <p> 
        We revisit the under-explored phenomenon of syntactic complexity convergence in dialogue. Extending prior topic-level analyses to full conversations, we examine five human-human datasets and a set of human-LLM dialogues. We integrate and evaluate a multidimensional set of syntactic complexity metrics to quantify structural variation in dialogue. Our analyses reveal robust syntactic complexity convergence across human-human datasets, especially in task-oriented interactions, and statistical tests confirm that these effects are not due to chance. In contrast, human-LLM dialogues show no significant convergence under individual metrics; however, linear-CKA uncovers a distinct cross-metric convergence pattern. Motivated by these differences, we use syntactic complexity as a feature for detecting LLM-involved dialogue, achieving 96% accuracy. Our classification results demonstrate its potential without relying on likelihood-based signals such as surprisal, which require a language model as the estimator. 
      </p>
    ),
  },
  {
    authors: "Christoph Leiter, Haiyue Song, Hour Kaing, Jin Tei, Hideki Tanaka, Masao Utiyama, Steffen Eger",
    title:
      "ExCAM: Explainable Cultural Awareness Metrics",
    venue: "EMNLP 2026 Findings",
    paper: "https://arxiv.org/abs/2605.29897",
    abstract: (
      <p> 
        Evaluating the cultural awareness of large language models is crucial to ensure the fairness of generated text and the generalizability of applications across the world. Recent benchmarks explore cultural goods like food or values like behavior in stressful situations through the lens of question answering or text generation tasks. However, creating these benchmarks requires time-intensive and costly human annotations. Also, benchmarks that evaluate cultural awareness in free text are scarce and often rely on dated evaluation mechanisms. To address this gap, we introduce ExCAM, an Explainable Cultural Awareness Metric, which is, to our knowledge, the first dedicated evaluation metric that identifies, rates and explains cultural errors in instruction-output pairs. To train and evaluate ExCAM, we introduce ExCAM40k, a dataset comprised of nine existing benchmarks that we reformat and enhance with synthetic errors. Compared to several baselines, including GPT-5, ExCAM achieves the highest error detection rate with up to 80% accuracy on a balanced test set. Therefore, ExCAM opens the pathway towards fine-grained and explainable cultural evaluation of free text.
      </p>
    ),
  },
  {
    authors: "Ran Zhang, Steffen Eger, Arda Tezcan, Wei Zhao, Simone Paolo Ponzetto, Lieve Macken",
    title:
      "Beyond Reproduction: A Paired-Task Framework for Assessing LLM Comprehension and Creativity in Literary Translation",
    venue: "ACL 2026 Findings",
    paper: "https://aclanthology.org/2026.findings-acl.2030/",
    abstract: (
      <p> 
             Large language models (LLMs) are increasingly used for creative tasks such as literary translation. Yet translational creativity remains underexplored and is rarely evaluated at scale, while source-text comprehension is typically studied in isolation, despite the fact that, in professional translation, comprehension and creativity are tightly intertwined. We address these gaps with a paired-task framework applied to literary excerpts from 11 books. Task 1 assesses source-text comprehension, and Task 2 evaluates translational creativity through Units of Creative Potential (UCPs), such as metaphors and wordplay. Using a scalable evaluation setup that combines expert human annotations with UCP-based automatic scoring, we benchmark 23 models and four creativity-oriented prompts. Our findings show that strong comprehension does not translate into human-level creativity: models often produce literal or contextually inappropriate renderings, with particularly large gaps for the more distant English–Chinese language pair. Creativity-oriented prompts yield only modest gains, and only one model, Mistral-Large, comes close to human-level creativity (0.167 vs. 0.246). Across all model–prompt combinations, only three exceed a creativity score of 0.1, while the rest remain at or near zero.
      </p>
    ),
  },
    {
    authors: "Lotta Kiefer, Christoph Leiter, Sotaro Takeshita, Elena Schmidt, Steffen Eger",
    title:
      "GerAV: Towards New Heights in German Authorship Verification using Fine-Tuned LLMs on a New Benchmark",
    venue: "ACL 2026 Findings",
    paper: "https://aclanthology.org/2026.findings-acl.1991/",
    abstract: (
      <p> 
             Authorship verification (AV) is the task of determining whether two texts were written by the same author and has been studied extensively, predominantly for English data. In contrast, large-scale benchmarks and systematic evaluations for other languages remain scarce. We address this gap by introducing GerAV, a comprehensive benchmark for German AV comprising over 400k labeled text pairs. GerAV is built from Twitter and Reddit data, with the Reddit part further divided into in-domain and cross-domain message-based subsets, as well as a profile-based subset. This design enables controlled analysis of the effects of data source, topical domain, and text length. Using the provided training splits, we conduct a systematic evaluation of strong baselines and state-of-the-art models and find that our best approach, a fine-tuned large language model, outperforms recent baselines by up to 0.09 absolute F1 score and surpasses GPT-5 in a zero-shot setting by 0.08. We further observe a trade-off between specialization and generalization: models trained on specific data types perform best under matching conditions but generalize less well across data regimes, a limitation that can be mitigated by combining training sources. Overall, GerAV provides a challenging and versatile benchmark for advancing research on German and cross-domain AV.
      </p>
    ),
  },
  {
    authors: "Yanran Chen, Wei Zhao, Anne Breitbarth, Manuel Stoeckel, Alexander Mehler, Dominik Schlechtweg, Steffen Eger",
    title:
      "Syntactic Language Change in English and German: Metrics, Parsers, and Convergences",
    venue: "PLOS One 2026",
    paper: "https://arxiv.org/abs/2402.11549",
    abstract: (
      <p> 
             Many studies have shown that human languages tend to optimize for lower complexity and increased communication efficiency. Syntactic dependency distance, which measures the linear distance between dependent words, is often considered a key indicator of language processing difficulty and working memory load. The current paper looks at diachronic trends in syntactic language change in both English and German, using corpora of parliamentary debates from the last c. 160 years. We base our observations on five dependency parsers, including the widely used Stanford CoreNLP as well as 4 newer alternatives. Our analysis of syntactic language change goes beyond linear dependency distance and explores 15 metrics relevant to dependency distance minimization (DDM) and/or based on tree graph properties, such as the tree height and degree variance. Even though we have evidence that recent parsers trained on modern treebanks are not heavily affected by data 'noise' such as spelling changes and OCR errors in our historic data, we find that results of syntactic language change are sensitive to the parsers involved, which is a caution against using a single parser for evaluating syntactic language change as done in previous work. We also show that syntactic language change over the time period investigated is largely similar between English and German for the different metrics explored: only 4% of cases we examine yield opposite conclusions regarding upwards and downtrends of syntactic metrics across German and English. We also show that changes in syntactic measures seem to be more frequent at the tails of sentence length distributions. To our best knowledge, ours is the most comprehensive analysis of syntactic language change using modern NLP technology in recent corpora of English and German. 
      </p>
    ),
  },
  {
    authors: "Christoph Leiter, Yuki M. Asano, Margret Keuper, Steffen Eger",
    title:
      "CROC: Evaluating and Training T2I Metrics with Pseudo- and Human-Labeled Contrastive Robustness Checks",
    venue: "TACL 2026",
    paper: "https://arxiv.org/abs/2505.11314",
    abstract: (
      <p> 
             The assessment of evaluation metrics (meta-evaluation) is crucial for determining the suitability of existing metrics in text-to-image (T2I) generation tasks. Human-based meta-evaluation is costly and time-intensive, and automated alternatives are scarce. We address this gap and propose CROC: a scalable framework for automated Contrastive Robustness Checks that systematically probes and quantifies metric robustness by synthesizing contrastive test cases across a comprehensive taxonomy of image properties. With CROC, we generate a pseudo-labeled dataset (CROC   ) of over one million contrastive prompt-image pairs to enable a fine-grained comparison of evaluation metrics. We also use the dataset to train CROCScore, a new metric that achieves state-of-the-art performance among open-source methods, demonstrating an additional key application of our framework. To complement this dataset, we introduce a human-supervised benchmark (CROC   ) targeting especially challenging categories. Our results highlight robustness issues in existing metrics: for example, many fail on prompts involving negation, and all tested open-source metrics fail on at least 25% of cases involving correct identification of body parts. 
      </p>
    ),
  },
  {
    authors: "Yanran Chen, Lynn Greschner, Roman Klinger, Michael Klenk, Steffen Eger",
    title:
      "Emotionally Charged, Logically Blurred: AI-driven Emotional Framing Impairs Human Fallacy Detection",
    venue: "EACL 2026",
    paper: "https://arxiv.org/abs/2510.09695",
    abstract: (
      <p> 
        Logical fallacies are common in public communication and can mislead audiences; fallacious arguments may still appear convincing despite lacking soundness, because convincingness is inherently subjective. We present the first computational study of how emotional framing interacts with fallacies and convincingness, using large language models (LLMs) to systematically change emotional appeals in fallacious arguments. We benchmark eight LLMs on injecting emotional appeal into fallacious arguments while preserving their logical structures, then use the best models to generate stimuli for a human study. Our results show that LLM-driven emotional framing reduces human fallacy detection in F1 by 14.5% on average. Humans perform better in fallacy detection when perceiving enjoyment than fear or sadness, and these three emotions also correlate with significantly higher convincingness compared to neutral or other emotion states. Our work has implications for AI-driven emotional manipulation in the context of fallacious argumentation.
      </p>
    ),
  },
  {
    authors: "Xiao Wang, Daniil Larionov, Siwei Wu, Yiqi Liu, Steffen Eger, Nafise Sadat Moosavi, Chenghua Lin",
    title:
      "ContrastScore: Towards Higher Quality, Less Biased, More Efficient Evaluation Metrics with Contrastive Evaluation",
    venue: "AACL 2025",
    paper: "https://arxiv.org/abs/2504.02106",
    abstract: (
      <p> 
        Evaluating the quality of generated text automatically remains a significant challenge. Conventional reference-based metrics have been shown to exhibit relatively weak correlation with human evaluations. Recent research advocates the use of large language models (LLMs) as source-based metrics for natural language generation (NLG) assessment. While promising, LLM-based metrics, particularly those using smaller models, still fall short in aligning with human judgments. In this work, we introduce ContrastScore, a contrastive evaluation metric designed to enable higher-quality, less biased, and more efficient assessment of generated text. We evaluate ContrastScore on two NLG tasks: machine translation and summarization. Experimental results show that ContrastScore consistently achieves stronger correlation with human judgments than both single-model and ensemble-based baselines. Notably, ContrastScore based on Qwen 3B and 0.5B even outperforms Qwen 7B, despite having only half as many parameters, demonstrating its efficiency. Furthermore, it effectively mitigates common evaluation biases such as length and likelihood preferences, resulting in more robust automatic evaluation. 
      </p>
    ),
  },
  {
    authors: "Moritz Altemeyer, Steffen Eger, Johannes Daxenberger, Yanran Chen, Tim Altendorf, Philipp Cimiano, Benjamin Schiller",
    title:
      "Argument Summarization and its Evaluation in the Era of Large Language Models",
    venue: "EMNLP 2025",
    paper: "https://arxiv.org/abs/2503.00847",
    abstract: (
      <p> 
        Large Language Models (LLMs) have revolutionized various Natural Language Generation (NLG) tasks, including Argument Summarization (ArgSum), a key subfield of Argument Mining (AM). This paper investigates the integration of state-of-the-art LLMs into ArgSum, including for its evaluation. In particular, we propose a novel prompt-based evaluation scheme, and validate it through a novel human benchmark dataset. Our work makes three main contributions: (i) the integration of LLMs into existing ArgSum frameworks, (ii) the development of a new LLM-based ArgSum system, benchmarked against prior methods, and (iii) the introduction of an advanced LLM-based evaluation scheme. We demonstrate that the use of LLMs substantially improves both the generation and evaluation of argument summaries, achieving state-of-the-art results and advancing the field of ArgSum. We also show that among the four LLMs integrated in (i) and (ii), Qwen-3-32B, despite having the fewest parameters, performs best, even surpassing GPT-4o, while LLaMA-3.3-70B consistently underperforms. 
      </p>
    ),
  },
  {
    authors: "Ran Zhang, Wei Zhao, Lieve Macken, Steffen Eger",
    title:
      "LiTransProQA: an LLM-based Literary Translation evaluation metric with Professional Question Answering",
    venue: "EMNLP 2025",
    paper: "https://arxiv.org/abs/2505.05423",
    abstract: (
      <p> 
        The impact of Large Language Models (LLMs) has extended into literary domains. However, existing evaluation metrics prioritize mechanical accuracy over artistic expression and tend to overrate machine translation as being superior to human translation from experienced professionals. In the long run, this bias could result in an irreversible decline in translation quality and cultural authenticity. In response to the urgent need for a specialized literary evaluation metric, we introduce LiTransProQA, a novel, reference-free, LLM-based question-answering framework designed for literary translation evaluation. LiTransProQA uniquely integrates insights from professional literary translators and researchers, focusing on critical elements in literary quality assessment such as literary devices, cultural understanding, and authorial voice. Our extensive evaluation shows that while literary-finetuned XCOMET-XL yields marginal gains, LiTransProQA substantially outperforms current metrics, achieving up to 0.07 gain in correlation and surpassing the best state-of-the-art metrics by over 15 points in adequacy assessments. Incorporating professional translator insights as weights further improves performance, highlighting the value of translator inputs. Notably, LiTransProQA reaches human-level evaluation performance comparable to trained student evaluators. It shows broad applicability to open-source models like LLaMa3.3-70b and Qwen2.5-32b, indicating its potential as an accessible and training-free tool for evaluating literary translations that require local processing due to copyright or ethical considerations. 
      </p>
    ),
  },
  {
    authors: "Shuzhou Yuan, Jingyi Sun, Ran Zhang, Michael Färber, Steffen Eger, Pepa Atanasova, Isabelle Augenstein",
    title:
      "Graph-Guided Textual Explanation Generation Framework",
    venue: "EMNLP 2025",
    paper: "https://arxiv.org/abs/2412.12318",
    abstract: (
      <p> 
        Natural language explanations (NLEs) are commonly used to provide plausible free-text explanations of a model's reasoning about its predictions. However, recent work has questioned their faithfulness, as they may not accurately reflect the model's internal reasoning process regarding its predicted answer. In contrast, highlight explanations--input fragments critical for the model's predicted answers--exhibit measurable faithfulness. Building on this foundation, we propose G-Tex, a Graph-Guided Textual Explanation Generation framework designed to enhance the faithfulness of NLEs. Specifically, highlight explanations are first extracted as faithful cues reflecting the model's reasoning logic toward answer prediction. They are subsequently encoded through a graph neural network layer to guide the NLE generation, which aligns the generated explanations with the model's underlying reasoning toward the predicted answer. Experiments on T5 and BART using three reasoning datasets show that G-Tex improves NLE faithfulness by up to 12.18% compared to baseline methods. Additionally, G-Tex generates NLEs with greater semantic and lexical similarity to human-written ones. Human evaluations show that G-Tex can decrease redundant content and enhance the overall quality of NLEs. Our work presents a novel method for explicitly guiding NLE generation to enhance faithfulness, serving as a foundation for addressing broader criteria in NLE and generated text. 
      </p>
    ),
  },
  {
    authors: "Daniil Larionov, Steffen Eger",
    title:
      "BatchGEMBA: Token-Efficient Machine Translation Evaluation with Batched Prompting and Prompt Compression",
    venue: "EMNLP 2025",
    paper: "https://arxiv.org/abs/2412.12318",
    abstract: (
      <p> 
     Recent advancements in Large Language Model (LLM)-based Natural Language Generation evaluation have largely focused on single-example prompting, resulting in significant token overhead and computational inefficiencies. In this work, we introduce BatchGEMBA-MQM, a framework that integrates batched prompting with the GEMBA-MQM metric for machine translation evaluation. Our approach aggregates multiple translation examples into a single prompt, reducing token usage by 2-4 times (depending on the batch size) relative to single-example prompting. Furthermore, we propose a batching-aware prompt compression model that achieves an additional token reduction of 13-15% on average while also showing ability to help mitigate batching-induced quality degradation. Evaluations across several LLMs (GPT-4o, GPT-4o-mini, Mistral Small, Phi4, and CommandR7B) and varying batch sizes reveal that while batching generally negatively affects quality (but sometimes not substantially), prompt compression does not degrade further, and in some cases, recovers quality loss. For instance, GPT-4o retains over 90% of its baseline performance at a batch size of 4 when compression is applied, compared to a 44.6% drop without compression. We plan to release our code and trained models at this https URL to support future research in this domain.       </p>
    ),
  },
  {
    authors: "Jonas Belouadi, Eddy Ilg, Margret Keuper, Hideki Tanaka, Masao Utiyama, Raj Dabre, Steffen Eger, Simone Paolo Ponzetto",
    title:
      "TikZero: Zero-Shot Text-Guided Graphics Program Synthesis",
    venue: "ICCV 2025",
    paper: "https://arxiv.org/abs/2503.11509",
    abstract: (
      <p>
        With the rise of generative AI, synthesizing figures from text captions becomes a compelling 
        application. However, achieving high geometric precision and editability requires representing 
        figures as graphics programs in languages like TikZ, and aligned training data (i.e., graphics 
        programs with captions) remains scarce. Meanwhile, large amounts of unaligned graphics programs 
        and captioned raster images are more readily available. We reconcile these disparate data sources 
        by presenting TikZero, which decouples graphics program generation from text understanding by using 
        image representations as an intermediary bridge. It enables independent training on graphics 
        programs and captioned images and allows for zero-shot text-guided graphics program synthesis 
        during inference. We show that our method substantially outperforms baselines that can only operate 
        with caption-aligned graphics programs. Furthermore, when leveraging caption-aligned graphics programs 
        as a complementary training signal, TikZero matches or exceeds the performance of much larger models,
         including commercial systems like GPT-4o. Our code, datasets, and select models are publicly available.  
      </p>
    ),
  },
  {
    authors: "Ran Zhang, Steffen Eger",
    title:
      "LLM-based multi-agent poetry generation in non-cooperative environments",
    venue: "JLM (Journal of Language Modeling) 2025",
    paper: "https://arxiv.org/abs/2409.03659",
    abstract: (
      <p>
        Despite substantial progress of large language models (LLMs) for automatic poetry generation, 
        the generated poetry lacks diversity while the training process differs greatly from human 
        learning. Under the rationale that the learning process of the poetry generation systems should 
        be more human-like and their output more diverse and novel, we introduce a framework based on 
        social learning where we emphasize non-cooperative interactions besides cooperative interactions 
        to encourage diversity. Our experiments are the first attempt at LLM-based multi-agent systems in 
        non-cooperative environments for poetry generation employing both TRAINING-BASED agents (GPT-2) 
        and PROMPTING-BASED agents (GPT-3 and GPT-4). Our evaluation based on 96k generated poems shows 
        that our framework benefits the poetry generation process for TRAINING-BASED agents resulting in 
        1) a 3.0-3.7 percentage point (pp) increase in diversity and a 5.6-11.3 pp increase in novelty 
        according to distinct and novel n-grams. The generated poetry from TRAINING-BASED agents also 
        exhibits group divergence in terms of lexicons, styles and semantics. PROMPTING-BASED agents in 
        our framework also benefit from non-cooperative environments and a more diverse ensemble of models 
        with non-homogeneous agents has the potential to further enhance diversity, with an increase of 
        7.0-17.5 pp according to our experiments. However, PROMPTING-BASED agents show a decrease in 
        lexical diversity over time and do not exhibit the group-based divergence intended in the social 
        network. Our paper argues for a paradigm shift in creative tasks such as automatic poetry generation 
        to include social learning processes (via LLM-based agent modeling) similar to human interaction. 
      </p>
    ),
  },
  {
    authors: "Yanran Chen, Steffen Eger",
    title:
      "Do Emotions Really Affect Argument Convincingness? A Dynamic Approach with LLM-based Manipulation Checks",
    venue: "ACL 2025",
    paper: "https://arxiv.org/abs/2503.00024",
    abstract: (
      <p>
        Emotions have been shown to play a role in argument convincingness, yet this aspect is underexplored
        in the natural language processing (NLP) community. Unlike prior studies that use static analyses,
        focus on a single text domain or language, or treat emotion as just one of many factors, we introduce
        a dynamic framework inspired by manipulation checks commonly used in psychology and social science;
        leveraging LLM-based manipulation checks, this framework examines the extent to which perceived emotional
        intensity influences perceived convincingness. Through human evaluation of arguments across different
        languages, text domains, and topics, we find that in over half of cases, judgments of convincingness remain
        unchanged despite variations in perceived emotional intensity; when emotions do have an impact, they more
        often enhance rather than weaken convincingness. We further analyze how 11 LLMs behave in the same scenario,
        finding that while LLMs generally mirror human patterns, they struggle to capture nuanced emotional effects
        in individual judgments.
      </p>
    ),
  },
  {
    authors: "Ran Zhang, Wei Zhao, Steffen Eger",
    title:
      "How Good Are LLMs for Literary Translation, Really? Literary Translation Evaluation with Humans and LLMs",
    venue: "NAACL 2025",
    paper: "https://aclanthology.org/2025.naacl-long.548/",
    abstract: (
      <p>
        Recent research has focused on literary machine translation (MT) as a new challenge in MT.
        However, the evaluation of literary MT remains an open problem. We contribute to this ongoing
        discussion by introducing LITEVAL-CORPUS, a paragraph-level parallel corpus containing verified
        human translations and outputs from 9 MT systems, which totals over 2k translations and 13k
        evaluated sentences across four language pairs, costing 4.5k€. This corpus enables us to (i)
        examine the consistency and adequacy of human evaluation schemes with various degrees of complexity,
        (ii) compare evaluations by students and professionals, assess the effectiveness of (iii) LLM-based
        metrics and (iv) LLMs themselves. Our findings indicate that the adequacy of human evaluation is
        controlled by two factors: the complexity of the evaluation scheme (more complex is less adequate)
        and the expertise of evaluators (higher expertise yields more adequate evaluations). For instance,
        MQM (Multidimensional Quality Metrics), a complex scheme and the de facto standard for non-literary
        human MT evaluation, is largely inadequate for literary translation evaluation: with student evaluators,
        nearly 60% of human translations are misjudged as indistinguishable or inferior to machine translations.
        In contrast, BWS (BEST-WORST SCALING), a much simpler scheme, identifies human translations at a rate of
        80-100%. Automatic metrics fare dramatically worse, with rates of at most 20%. Our overall evaluation
        indicates that published human translations consistently outperform LLM translations, where even the most
        recent LLMs tend to produce considerably more literal and less diverse translations compared to humans.
      </p>
    ),
  },
  {
    authors: "Daniil Larionov, Steffen Eger",
    title:
      "PromptOptMe: Error-Aware Prompt Compression for LLM-based MT Evaluation Metrics",
    venue: "NAACL 2025",
    paper: "https://aclanthology.org/2025.naacl-long.592/",
    abstract: (
      <p>
        Evaluating the quality of machine-generated natural language content is a challenging
        task in Natural Language Processing (NLP). Recently, large language models (LLMs) like
        GPT-4 have been employed for this purpose, but they are computationally expensive due
        to the extensive token usage required by complex evaluation prompts. In this paper, we
        propose a prompt optimization approach that uses a smaller, fine-tuned language model
        to compress input data for evaluation prompt, thus reducing token usage and computational
        cost when using larger LLMs for downstream evaluation. Our method involves a two-stage
        fine-tuning process: supervised fine-tuning followed by preference optimization to refine
        the model’s outputs based on human preferences. We focus on Machine Translation (MT)
        evaluation and utilize the GEMBA-MQM metric as a starting point. Our results show a 2.37×
        reduction in token usage without any loss in evaluation quality. This work makes state-of-the-art
        LLM-based metrics like GEMBA-MQM more cost-effective and efficient, enhancing their
        accessibility for broader use.
      </p>
    ),
  },
  {
    authors: "Jonas Belouadi, Simone Paolo Ponzetto and Steffen Eger",
    title:
      "DeTikZify: Synthesizing Graphics Programs for Scientific Figures and Sketches with TikZ",
    venue: "NeurIPS 2024",
    paper: "https://arxiv.org/abs/2405.15306",
    abstract: (
      <p>
        Creating high-quality scientific figures can be time-consuming and
        challenging, even though sketching ideas on paper is relatively easy.
        Furthermore, recreating existing figures that are not stored in formats
        preserving semantic information is equally complex. To tackle this
        problem, we introduce DeTikZify, a novel multimodal language model that
        automatically synthesizes scientific figures as semantics-preserving
        TikZ graphics programs based on sketches and existing figures. To
        achieve this, we create three new datasets: DaTikZv2, the largest TikZ
        dataset to date, containing over 360k human-created TikZ graphics;
        SketchFig, a dataset that pairs hand-drawn sketches with their
        corresponding scientific figures; and SciCap++, a collection of diverse
        scientific figures and associated metadata. We train DeTikZify on
        SciCap++ and DaTikZv2, along with synthetically generated sketches
        learned from SketchFig. We also introduce an MCTS-based inference
        algorithm that enables DeTikZify to iteratively refine its outputs
        without the need for additional training. Through both automatic and
        human evaluation, we demonstrate that DeTikZify outperforms commercial
        Claude 3 and GPT-4V in synthesizing TikZ programs, with the MCTS
        algorithm effectively boosting its performance. We make our code,
        models, and datasets publicly available.
      </p>
    ),
  },
  {
    authors:
      "Aida Kostikova, Dominik Beese, Benjamin Paaßen, Ole Pütz, Gregor Wiedemann and Steffen Eger",
    title:
      "Fine-Grained Detection of Solidarity for Women and Migrants in 155 Years of German Parliamentary Debates",
    venue: "EMNLP 2024",
    paper: "https://pub.uni-bielefeld.de/record/2992769",
    abstract: (
      <p>
        Solidarity is a crucial concept to understand social relations in
        societies. In this paper, we explore fine-grained solidarity frames to
        study solidarity towards women and migrants in German parliamentary
        debates between 1867 and 2022. Using 2,864 manually annotated text
        snippets (with a cost exceeding 18k Euro), we evaluate large language
        models (LLMs) like Llama 3, GPT-3.5, and GPT-4. We find that GPT-4
        outperforms other LLMs, approaching human annotation quality. Using
        GPT-4, we automatically annotate more than 18k further instances (with a
        cost of around 500 Euro) across 155 years and find that solidarity with
        migrants outweighs anti-solidarity but that frequencies and solidarity
        types shift over time. Most importantly, group-based notions of
        (anti-)solidarity fade in favor of compassionate solidarity, focusing on
        the vulnerability of migrant groups, and exchange-based anti-solidarity,
        focusing on the lack of (economic) contribution. Our study highlights
        the interplay of historical events, socio-economic needs, and political
        ideologies in shaping migration discourse and social cohesion. We also
        show that powerful LLMs, if carefully prompted, can be cost-effective
        alternatives to human annotation for hard social scientific tasks.
      </p>
    ),
  },
  {
    authors:
      "Daniil Larionov, Mikhail Seleznyov, Vasiliy Viskov, Alexander Panchenko and Steffen Eger",
    title:
      "xCOMET-lite: Bridging the Gap Between Efficiency and Quality in Learned MT Evaluation Metrics",
    venue: "EMNLP 2024",
    paper: "https://arxiv.org/abs/2406.14553",
    abstract: (
      <p>
        State-of-the-art trainable machine translation evaluation metrics like
        xCOMET achieve high correlation with human judgment but rely on large
        encoders (up to 10.7B parameters), making them computationally expensive
        and inaccessible to researchers with limited resources. To address this
        issue, we investigate whether the knowledge stored in these large
        encoders can be compressed while maintaining quality. We employ
        distillation, quantization, and pruning techniques to create efficient
        xCOMET alternatives and introduce a novel data collection pipeline for
        efficient black-box distillation. Our experiments show that, using
        quantization, xCOMET can be compressed up to three times with no quality
        degradation. Additionally, through distillation, we create an
        xCOMET-lite metric, which has only 2.6% of xCOMET-XXL parameters, but
        retains 92.1% of its quality. Besides, it surpasses strong small-scale
        metrics like COMET-22 and BLEURT-20 on the WMT22 metrics challenge
        dataset by 6.4%, despite using 50% fewer parameters. All code, dataset,
        and models are available online.
      </p>
    ),
  },
  {
    authors: "Yanran Chen, Hannes Gröner, Sina Zarrieß and Steffen Eger",
    title: "Evaluating Diversity in Automatic Poetry Generation",
    venue: "EMNLP 2024",
    paper: "https://arxiv.org/abs/2406.15267",
    abstract: (
      <p>
        Natural Language Generation (NLG), and more generally generative AI, are
        among the currently most impactful research fields. Creative NLG, such
        as automatic poetry generation, is a fascinating niche in this area.
        While most previous research has focused on forms of the Turing test
        when evaluating automatic poetry generation - can humans distinguish
        between automatic and human generated poetry - we evaluate the diversity
        of automatically generated poetry, by comparing distributions of
        generated poetry to distributions of human poetry along structural,
        lexical, semantic and stylistic dimensions, assessing different model
        types (word vs. character-level, general purpose LLMs vs.
        poetry-specific models), including the very recent LLaMA3, and types of
        fine-tuning (conditioned vs. unconditioned). We find that current
        automatic poetry systems are considerably underdiverse along multiple
        dimensions - they often do not rhyme sufficiently, are semantically too
        uniform and even do not match the length distribution of human poetry.
        Our experiments reveal, however, that style-conditioning and
        character-level modeling clearly increases diversity across virtually
        all dimensions we explore. Our identified limitations may serve as the
        basis for more genuinely diverse future poetry generation models.
      </p>
    ),
  },
  {
    authors: "Christoph Leiter and Steffen Eger",
    title:
      "PrExMe! Large Scale Prompt Exploration of Open Source LLMs for Machine Translation and Summarization Evaluation",
    venue: "EMNLP 2024",
    paper: "https://arxiv.org/abs/2406.18528",
    abstract: (
      <p>
        Large language models (LLMs) have revolutionized the field of NLP.
        Notably, their in-context learning capabilities also enable their use as
        evaluation metrics for natural language generation, making them
        particularly advantageous in low-resource scenarios and time-restricted
        applications. In this work, we introduce PrExMe, a large-scale prompt
        exploration for metrics, where we evaluate more than 720 prompt
        templates for open-source LLM-based metrics on machine translation (MT)
        and summarization datasets, totalling over 6.6M evaluations. This
        extensive comparison (1) serves as a benchmark of the performance of
        recent open-source LLMs as metrics and (2) explores the stability and
        variability of different prompting strategies. We discover that, on the
        one hand, there are scenarios for which prompts are stable. For
        instance, some LLMs show idiosyncratic preferences and favor to grade
        generated texts with textual labels while others prefer to return
        numeric scores. On the other hand, the stability of prompts and model
        rankings can be susceptible to seemingly innocuous changes. For example,
        changing the requested output format from "0 to 100" to "-1 to +1" can
        strongly affect the rankings in our evaluation. Our study contributes to
        understanding the impact of different prompting approaches on LLM-based
        metrics for MT and summarization evaluation, highlighting the most
        stable prompting patterns and potential limitations.
      </p>
    ),
  },
  {
    authors: "Ran Zhang, Jihed Ouni and Steffen Eger",
    title:
      "Cross-lingual Cross-temporal Summarization: Dataset, Models, Evaluation",
    venue: '"Computational Linguistics" (CL), 2024',
    paper: "https://arxiv.org/abs/2306.12916",
    abstract: (
      <p>
        While summarization has been extensively researched in natural language
        processing (NLP), cross-lingual cross-temporal summarization (CLCTS) is
        a largely unexplored area that has the potential to improve
        cross-cultural accessibility and understanding. This paper
        comprehensively addresses the CLCTS task, including dataset creation,
        modeling, and evaluation. We build the first CLCTS corpus, leveraging
        historical fictive texts and Wikipedia summaries in English and German,
        and examine the effectiveness of popular transformer end-to-end models
        with different intermediate finetuning tasks. Additionally, we explore
        the potential of ChatGPT for CLCTS as a summarizer and an evaluator.
        Overall, we report evaluations from humans, ChatGPT, and several recent
        automatic evaluation metrics where we find that our intermediate task
        finetuned end-to-end models generate bad to moderate quality summaries;
        ChatGPT as a summarizer (without any finetuning) provides moderate to
        good quality outputs and as an evaluator correlates moderately with
        human evaluations but is prone to giving lower scores. ChatGPT also
        seems very adept at normalizing historical text and outperforms
        context-unaware spelling normalization tools such as Norma. We finally
        test ChatGPT in a scenario with adversarially attacked and unseen source
        documents and find that ChatGPT profits from its prior knowledge to a
        certain degree, with better performances for omission and entity swap
        than negation against its prior knowledge. This benefit inflates its
        assessed quality as ChatGPT performs slightly worse for unseen source
        documents compared to seen documents. We additionally introspect our
        models' performances to find that longer, older and more complex source
        texts (all of which are more characteristic for historical language
        variants) are harder to summarize for all models, indicating the
        difficulty of the CLCTS task.
      </p>
    ),
  },
  {
    authors:
      "Christoph Leiter, Ran Zhang, Yanran Chen, Jonas Belouadi, Daniil Larionov, Vivian Fresen, Steffen Eger",
    title: "ChatGPT: A Meta-Analysis after 2.5 Months",
    venue: '"Machine Learning with Applications" (MLWA), 2024',
    paper: "https://arxiv.org/abs/2302.13795",
    abstract: (
      <p>
        ChatGPT, a chatbot developed by OpenAI, has gained widespread popularity
        and media attention since its release in November 2022. However, little
        hard evidence is available regarding its perception in various sources.
        In this paper, we analyze over 300,000 tweets and more than 150
        scientific papers to investigate how ChatGPT is perceived and discussed.
        Our findings show that ChatGPT is generally viewed as of high quality,
        with positive sentiment and emotions of joy dominating in social media.
        Its perception has slightly decreased since its debut, however, with joy
        decreasing and (negative) surprise on the rise, and it is perceived more
        negatively in languages other than English. In recent scientific papers,
        ChatGPT is characterized as a great opportunity across various fields
        including the medical domain, but also as a threat concerning ethics and
        receives mixed assessments for education. Our comprehensive
        meta-analysis of ChatGPT's current perception after 2.5 months since its
        release can contribute to shaping the public debate and informing its
        future development. We make our data available.
      </p>
    ),
  },
  {
    authors: "Gil Rocha, Henrique Lopes Cardoso, Jonas Belouadi, Steffen Eger",
    title:
      "Cross-Genre Argument Mining: Can Language Models Automatically Fill in Missing Discourse Markers?",
    venue: 'Journal of "Argumentation & Computation"',
    paper: "https://arxiv.org/abs/2306.04314",
    abstract: (
      <p>
        Available corpora for Argument Mining differ along several axes, and one
        of the key differences is the presence (or absence) of discourse markers
        to signal argumentative content. Exploring effective ways to use
        discourse markers has received wide attention in various discourse
        parsing tasks, from which it is well-known that discourse markers are
        strong indicators of discourse relations. To improve the robustness of
        Argument Mining systems across different genres, we propose to
        automatically augment a given text with discourse markers such that all
        relations are explicitly signaled. Our analysis unveils that popular
        language models taken out-of-the-box fail on this task; however, when
        fine-tuned on a new heterogeneous dataset that we construct (including
        synthetic and real examples), they perform considerably better. We
        demonstrate the impact of our approach on an Argument Mining downstream
        task, evaluated on different corpora, showing that language models can
        be trained to automatically fill in discourse markers across different
        corpora, improving the performance of a downstream model in some, but
        not all, cases. Our proposed approach can further be employed as an
        assistive tool for better discourse understanding.{" "}
      </p>
    ),
  },
  {
    authors:
      "Christoph Leiter, Piyawat Lertvittayakumjorn, M. Fomicheva, Wei Zhao, Yang Gao, Steffen Eger",
    title: "Towards Explainable Evaluation Metrics for Machine Translation",
    venue: '"Journal of Machine Learning Research" (JMLR), 2024',
    paper: "https://jmlr.org/papers/v25/22-0416.html",
    abstract: (
      <p>
        Unlike classical lexical overlap metrics such as BLEU, most current
        evaluation metrics for machine translation (for example, COMET or
        BERTScore) are based on black-box large language models. They often
        achieve strong correlations with human judgments, but recent research
        indicates that the lower-quality classical metrics remain dominant, one
        of the potential reasons being that their decision processes are more
        transparent. To foster more widespread acceptance of novel high-quality
        metrics, explainability thus becomes crucial. In this concept paper, we
        identify key properties as well as key goals of explainable machine
        translation metrics and provide a comprehensive synthesis of recent
        techniques, relating them to our established goals and properties. In
        this context, we also discuss the latest state-of-the-art approaches to
        explainable metrics based on generative models such as ChatGPT and GPT4.
        Finally, we contribute a vision of next-generation approaches, including
        natural language explanations. We hope that our work can help catalyze
        and guide future research on explainable evaluation metrics and,
        mediately, also contribute to better and more transparent machine
        translation systems.
      </p>
    ),
  },
  {
    authors: "Jonas Belouadi, Steffen Eger",
    title:
      "AutomaTikZ: Text-Guided Synthesis of Scientific Vector Graphics with TikZ",
    venue: "ICLR, 2024",
    paper: "https://arxiv.org/abs/2310.00367",
    code: "https://github.com/potamides/AutomaTikZ",
    abstract: (
      <p>
        Generating bitmap graphics from text has gained considerable attention,
        yet for scientific figures, vector graphics are often preferred. Given
        that vector graphics are typically encoded using low-level graphics
        primitives, generating them directly is difficult. To address this, we
        propose the use of TikZ, a well-known abstract graphics language that
        can be compiled to vector graphics, as an intermediate representation of
        scientific figures. TikZ offers human-oriented, high-level commands,
        thereby facilitating conditional language modeling with any large
        language model. To this end, we introduce DaTikZ, the first large-scale
        TikZ dataset consisting of 120k TikZ drawings aligned with captions. We
        fine-tune LLaMA on DaTikZ, as well as our new model CLiMA, which
        augments LLaMA with multimodal CLIP embeddings. In both human and
        automatic evaluation, CLiMA and LLaMA outperform commercial GPT-4 and
        Claude 2 in terms of similarity to human-created figures, with CLiMA
        additionally improving text-image alignment. Our detailed analysis shows
        that all models generalize well and are not susceptible to memorization.
        GPT-4 and Claude 2, however, tend to generate more simplistic figures
        compared to both humans and our models. We make our framework,
        AutomaTikZ, along with model weights and datasets, publicly available.
      </p>
    ),
  },
  {
    authors: "Christoph Leiter, Hoa Nguyen, Steffen Eger",
    title: "BMX: Boosting Machine Translation Metrics with Explainability",
    venue: "EACL, 2024",
    paper: "https://arxiv.org/abs/2212.10469",
    code: "https://github.com/Gringham/BMX",
  },
  {
    authors: "Daniil Larionov, Jens Grünwald, Christoph Leiter, Steffen Eger",
    title:
      "EffEval: A Comprehensive Evaluation of Efficiency for MT Evaluation Metrics",
    venue: "EMNLP, 2023",
    paper: "https://arxiv.org/abs/2209.09593",
    code: "https://github.com/NL2G/effeval",
  },
  {
    authors: "Christoph Leiter, Steffen Eger",
    title:
      "The Eval4NLP 2023 Shared Task on Prompting Large Language Models as Explainable Metrics",
    venue: "IJCNLP-AACL, 2023",
    paper: "https://arxiv.org/abs/2310.19792",
    code: "https://github.com/eval4nlp/SharedTask2023/tree/main",
  },
  {
    authors: "Jonas Belouadi, Steffen Eger",
    title:
      "ByGPT5: End-to-End Style-conditioned Poetry Generation with Token-free Language Models",
    venue: "ACL, 2023",
    paper: "https://aclanthology.org/2023.acl-long.406/",
    code: "https://github.com/potamides/uniformers",
  },
  {
    authors: "Yanran Chen, Steffen Eger",
    title: "MENLI: Robust Evaluation Metrics from Natural Language Inference",
    venue: "TACL, 2023",
    paper:
      "https://direct.mit.edu/tacl/article/doi/10.1162/tacl_a_00576/116715/MENLI-Robust-Evaluation-Metrics-from-Natural",
    code: "https://github.com/cyr19/MENLI",
  },
  {
    authors: "Jonas Belouadi, Steffen Eger",
    title:
      "USCORE: An Effective Approach to Fully Unsupervised Evaluation Metrics for Machine Translation",
    venue: "EACL, 2023",
    paper: "https://arxiv.org/abs/2202.10062",
    code: "https://github.com/potamides/unsupervised-metrics",
  },
  {
    authors: "Wei Zhao, Michael Strube, Steffen Eger",
    title:
      "DiscoScore: Evaluating Text Generation with BERT and Discourse Coherence",
    venue: "EACL, 2023",
    paper: "https://arxiv.org/abs/2201.11176",
    code: "https://github.com/AIPHES/DiscoScore",
  },
  {
    authors: "Yanran Chen, Jonas Belouadi, Steffen Eger",
    title: "Reproducibility Issues for BERT-based Evaluation Metrics",
    venue: "EMNLP, 2022",
    paper: "https://arxiv.org/abs/2204.00004",
    code: "https://github.com/cyr19/Reproducibility",
  },
  {
    authors: "Doan Nam Long Vu, Nafise Sadat Moosavi, Steffen Eger",
    title:
      "Layer or Representation Space: What makes BERT-based Evaluation Metrics Robust?",
    venue: "COLING 2022",
    paper: "https://arxiv.org/abs/2209.02317",
  },
  {
    authors: "Steffen Eger, Dan Liu, Daniela Grunow",
    title:
      "Measuring Social Solidarity During Crisis: The Role of Design Choices",
    venue: "Journal of Social Computing, 2022",
    paper: "https://ieeexplore.ieee.org/abstract/document/9832842",
  },
  {
    authors: "Wei Zhao, Steffen Eger",
    title:
      "Constrained Density Matching and Modeling for Cross-lingual Alignment of Contextualized Representations",
    venue: "ACML 2022",
    paper: "https://arxiv.org/abs/2201.13429",
  },
  {
    authors: "Marvin Kaster, Wei Zhao, Steffen Eger",
    title:
      "Global Explainability of BERT-based Evaluation Metrics by Disentangling along Linguistic Factors",
    venue: "EMNLP, 2021",
    paper: "https://arxiv.org/pdf/2110.04399.pdf",
    abstract: (
      <p>
        Evaluation metrics are a key ingredient for progress of text generation
        systems. In recent years, several BERT-based evaluation metrics have
        been proposed (including BERTScore, MoverScore, BLEURT, etc.) which
        correlate much better with human assessment of text generation quality
        than BLEU or ROUGE, invented two decades ago. However, little is known
        what these metrics, which are based on black-box language model
        representations, actually capture (it is typically assumed they model
        semantic similarity). In this work, we use a simple regression based
        global explainability technique to disentangle metric scores along
        linguistic factors, including semantics, syntax, morphology, and lexical
        overlap. We show that the different metrics capture all aspects to some
        degree, but that they are all substantially sensitive to lexical
        overlap, just like BLEU and ROUGE. This exposes limitations of these
        novelly proposed metrics, which we also highlight in an adversarial test
        scenario.
      </p>
    ),
  },
  {
    authors:
      "Marina Fomicheva, Piyawat Lertvittayakumjorn, Wei Zhao, Steffen Eger, Yang Gao",
    title:
      "The Eval4NLP Shared Task on Explainable Quality Estimation: Overview and Results",
    venue: "Eval4NLP, 2021",
    paper: "https://arxiv.org/abs/2110.04392",
    abstract: (
      <p>
        In this paper, we introduce the Eval4NLP-2021 shared task on explainable
        quality estimation. Given a source-translation pair, this shared task
        requires not only to provide a sentencelevel score indicating the
        overall quality of the translation, but also to explain this score by
        identifying the words that negatively impact translation quality. We
        present the data, annotation guidelines and evaluation setup of the
        shared task, describe the six participating systems, and analyze the
        results. To the best of our knowledge, this is the first shared task on
        explainable NLP evaluation metrics. Datasets and results are available
        at{" "}
        <a
          href="https://github.
com/eval4nlp/SharedTask2021"
        >
          https://github. com/eval4nlp/SharedTask2021
        </a>
      </p>
    ),
  },
];

export default PublicationsData;
